export const config = {
	apiUrl: `${process.env.NEXT_PUBLIC_API_URL}`,
	apiUrlServer: `${process.env.NEXT_PUBLIC_API_URL_SERVER}`,
	assetsUrl: `${process.env.NEXT_PUBLIC_ASSETS_URL}`,
	host: `${process.env.NEXT_PUBLIC_HOST}`,
};
